import { Component, OnInit, AfterContentInit, HostListener, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { ConditionTypeUtil, GroupAttributorTransformRule, GroupByType, GroupFillType, GroupFillTypeUtil, WhenType } from 'src/app/domainObjects/transformers/groupAttributorTransform';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { ColumnFilterInfo } from 'src/app/views/previewTable/filterUI/column-filter/column-filter.component';
import { PreviewTableComponent, ColumnInfo, IPreviewTableDelegate } from '../../../preview-table/preview-table.component';
import { SaveMappingConfigDialogComponent } from '../../../save-mapping-config-dialog/save-mapping-config-dialog.component';
import { GroupAttributorRuleViewModel } from './groupAttributorRuleViewModel';
import { GroupAttributorViewModel } from './groupAttributorViewModel';
import { WhenTypeUtil, ConditionType, GroupByTypeUtil, FillOptionTypeUtil, FillOptionType } from '../../../../domainObjects/transformers/groupAttributorTransform';
import { BaseTransformerUIComponent } from 'src/app/views/dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { TransformPipelineService } from 'src/app/services/transformPipeline/transform-pipeline.service';
import { DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { SortBuilderComponent } from 'src/app/views/transform/sort-builder/sort-builder.component';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { FieldValidationErrorViewComponent } from '../../../shared/fieldValidation/field-validation-error-view/field-validation-error-view.component';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { map,pick,isEqual } from 'lodash';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';
import { TransformerViewModel } from 'src/app/views/transformer-list/transformer-list.component';
import { TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { ExportColumnInfo, ExportViewModel } from 'src/app/viewModels/exportViewModel';
import { collectDistinctSourceFields } from 'src/app/views/shared/utils/source-field.util';
import { DataDictionaryType } from 'src/app/domainObjects/dataDictionaryType';
import { NodeRunStatus } from 'src/app/domainObjects/nodeRunStatus';
import { UpdateNodesStatusRequest } from 'src/app/model/RunrefineryRequest';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { TransformerTopHeaderComponent } from '../../transformer-top-header/transformer-top-header.component';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';
import { map as rxmap,startWith } from 'rxjs/operators';
import { SelectFilterInfo } from 'src/app/views/shared/select-filter-option/select-filter-option.component';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';

@Component({
    selector: 'app-group-attributor-transform-detail',
    templateUrl: './group-attributor-transform-detail.component.html',
    styleUrls: ['./group-attributor-transform-detail.component.css'],
    standalone: false
})
export class GroupAttributorTransformDetailComponent extends BaseTransformerUIComponent<GroupAttributorViewModel>
  implements OnInit, AfterContentInit, IPreviewTableDelegate,ComponentCanDeactivate {

  /** Distinct fields referenced by this config's rules (fieldStart and fieldEnd both count as
   * source fields here — GroupAttributor rules have no single source field per rule), Default
   * Source Field first — Smart Sample dropdown. */
  get groupAttributorAvailableSourceFields(): string[] {
    const defaultField = this.viewModel?.sourceColumn;
    const fromRules = collectDistinctSourceFields(
      this.viewModel?.rules, r => [r.fieldStart, r.fieldEnd].filter(Boolean),
    );
    if (!defaultField) return fromRules;
    return [defaultField, ...fromRules.filter(f => f !== defaultField)];
  }

  FillOptionTypeUtil = FillOptionTypeUtil;
  FillOptionType = FillOptionType;

  GroupFillTypeUtil = GroupFillTypeUtil;
  GroupFillType = GroupFillType;
  GroupFillTypes = [
    GroupFillType.beforeStartRow,
    GroupFillType.atStartRow,
    GroupFillType.afterStartRow,
    GroupFillType.atEndRow,
    GroupFillType.afterEndRow,
    GroupFillType.value
  ];

  WhenTypeUtil = WhenTypeUtil;
  WhenType = WhenType;

  StartGroupWhenTypes = [
    WhenType.changesFrom,
    WhenType.changesTo
  ];

  WhenTypes = [
    WhenType.changesTo,
    WhenType.changesFrom,
    WhenType.notInGroup
  ];

  ConditionTypeUtil = ConditionTypeUtil;
  ConditionType = ConditionType;
  ConditionTypes = [
    ConditionType.equals,
    ConditionType.contains,
    ConditionType.startsWith,
    ConditionType.endsWith,
    ConditionType.notEquals,
    ConditionType.notContains,
    ConditionType.notStartsWith,
    ConditionType.notEndsWith
  ];

  GroupByTypeUtil = GroupByTypeUtil;
  GroupByType = GroupByType;
  GroupByTypes = [
    GroupByType.ignore,
    GroupByType.changes
  ];

  dataSource: MatTableDataSource<GroupAttributorRuleViewModel> | undefined;
  displayedColumns: string[] = [
    'actions',
    'index',
    'name',
    'groupFill',
    'groupByValue',
    'fieldStart',
    'whenStart',
    'conditionStart',
    'stringStart',
    'groupByStart',
    'fieldEnd',
    'whenEnd',
    'conditionEnd',
    'stringEnd',
    'groupByEnd',
    'timeout',
    'include',
    'isEnabled',
    'sampleGroups',
    'sampleRows',
    'groups',
    'rows'];

  isRuleSetEmpty = true;
  isRuleExecuting = false;

  updateDataSource: any;

  previewDataViewModel = new ImportDataViewModel();
  isRulesMaximized = false;

  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();

  sortCtrl = new UntypedFormControl('');

  form: FormGroup;
  formparam: FormGroup;
  separatorControl:FormControl;
  separatorOptions: Observable<{ value: string; text: string }[]>;
  separators = [{ value: '|', text: '| (pipe)' },
    { value: ':', text: ': (colon)' },
    { value: ';', text: '; (semicolon) ' },
    { value: ',', text: ', (comma)' },
    { value: ' ', text: '" " (space)' },
    { value: '/', text: '/ Forward Slash' },
    { value: '\\', text: '\\ Backward Slash' }
  ];

  constructor(
    activeRoute: ActivatedRoute,
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    snackBar: MatSnackBar,
    router: Router,
    configViewModelService: ConfigViewModelService,
    configService: ConfigService,
    navService: NavigationService,
    transformPipelineService: TransformPipelineService,
    userData: UserDataService,
    dataDictService: DataDictionaryService,
    refineryPresence: RefineryPresenceService,
    private cdRef: ChangeDetectorRef,private fb: FormBuilder) {

    super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
    this.transformType = TransformType.groupAttributor;
  }
  selectedIndex: number = 0;
  isResultsPanelExpanded = false;
  isPreviewPanelExpanded = false;
  transformerInputPreviewCacheKey = "";
  //other parameters
  groupBy: ParameterSetting=new ParameterSetting();
  separateBy: ParameterSetting=new ParameterSetting();
  defTimeout: ParameterSetting=new ParameterSetting();
  defInclude: ParameterSetting=new ParameterSetting();
  //advanced settings parameters
  bufferRows: ParameterSetting=new ParameterSetting();
  threads: ParameterSetting=new ParameterSetting();
  listSeparator: ParameterSetting=new ParameterSetting();
  fillOptionType: ParameterSetting=new ParameterSetting();
  updateGroupsAtEnd: ParameterSetting=new ParameterSetting();
  resetRows: ParameterSetting=new ParameterSetting();

  @ViewChild(TransformerTopHeaderComponent) topHeaderComponent: TransformerTopHeaderComponent;
  options: string[] =[];
   defaultSourceColumn='Source Field';
  defaultTargetColumn='Target Field';
  transformType:TransformType;
  ngOnInit(): void {
    super.ngOnInit();
    this.userData.setInputTabClicked(false);
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.resetInputPrvwViewModel();
    this.transformerInputPreviewCacheKey = "";
    //validation
    this.formparam = this.fb.group({
      groupByField: [null, [Validators.required]],
      separateBy: [null, [Validators.required]],
      defTimeout:[null, [Validators.required]],
      defInclude:[null, [Validators.required]],
      defSourceField:[null, [Validators.required]],
      defTargetField:[null, [Validators.required]],
    });
    this.registerFormGroup(this.formparam);
    this.form = this.fb.group({
      bufferRows: ['', []],
      threads: ['', []],
      separatorControl: [null],
    });
    this.registerFormGroup(this.form);

    this.totalRulesColumnDisplay();
    this.configureDefaultSortBy();
  }

  protected override async onRouteActivated(_routeParams: any): Promise<void> {
    this.viewModel = new GroupAttributorViewModel(
      this.dataDictService,
      this.configService,
      this.dataTransformConfigViewModel,
      this.transformViewModel);
    this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
    this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
    this.snapshotPreState();

    this.dataSource = new MatTableDataSource<GroupAttributorRuleViewModel>(this.viewModel.rules);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;

    if (this.previewTable) { this.previewTable.clear(); }
    if (this.outputDataFarmPreviewTable) { this.outputDataFarmPreviewTable.clear(); }

    await this.setTransformerDetails(this.transformType);
    await this.downloadInputDataAsync();
    this.viewModel.parameters.sourceColumns = this.viewModel.sourceColumns;
    this.options=[...this.viewModel.sourceColumns.map(col => col.text).sort((a, b) => a.localeCompare(b))];
    this.viewModel.parameters.targetColumns=this.viewModel.targetColumns;
    await this.setDefaultValues(this.transformType);
    await this.removeInvalidValues();

    this.separatorControl = this.form.get('separatorControl') as FormControl;
    this.separatorOptions = this.separatorControl.valueChanges.pipe(
      startWith(''),
      rxmap((value) => this._filterSeparator(value || ''))
    );
  }
 
  private _filterSeparator(value: string): { value: string; text: string }[] {
    const filterValue = value.toLowerCase();
    return this.separators.filter((separator) =>
      separator.text.toLowerCase().includes(filterValue)
    );
  }
  onTransformTextChanged(){
    this.viewModel.transformViewModel.name=this.viewModel.transform.name;
    var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
    currenttransform.name=this.viewModel.transform.name;
    currenttransform.transform.name=this.viewModel.transform.name;
    var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
    vartransform.name=this.viewModel.transform.name;
  }
  dropTable(event: CdkDragDrop<MatTableDataSource<TransformRuleViewModel>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: GroupAttributorRuleViewModel = event.item.data;
    currentItem.index = prevIndex;
    moveItemInArray(this.viewModel.rules, prevIndex, event.currentIndex);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;
  }
  
  // configureDefaultSortBy(): void {
  //   this.onSeparateByChanged(null);

  //   // default secondary sort if it isn't already configured
  //   if (!this.viewModel.parameters.sortInfo?.find(x => x.sortField === this.viewModel.parameters.timeColumn)) {
  //     const secondarySort = new SortInfo();
  //     secondarySort.sortAscending = true;
  //     secondarySort.sortField = this.viewModel.timeColumn;

  //     // add secondary sort
  //     if (this.viewModel.parameters.sortInfo.length > 0) {
  //       this.viewModel.parameters.sortInfo.splice(1, 0, secondarySort);
  //     }
  //   }
  // }

  // onSeparateByChanged(event: any): void {

  //   if (this.viewModel.separateBy) {
  //     // add primary sort field 
  //     if (!this.viewModel.parameters.sortInfo) {
  //       this.viewModel.parameters.sortInfo = [];
  //     }

  //     // default primary sort if it isn't already configured
  //     if (!this.viewModel.parameters.sortInfo?.find(x => x.sortField === this.viewModel.separateBy)) {
  //       const primarySort = new SortInfo();
  //       primarySort.sortAscending = true;
  //       primarySort.sortField = this.viewModel.separateBy;

  //       // add primary sort
  //       if (this.viewModel.parameters.sortInfo?.length === 0) {
  //         this.viewModel.parameters.sortInfo.splice(0, 0, primarySort);
  //     } else {
  //        // update primary sort
  //        this.viewModel.parameters.sortInfo.splice(0, 1, primarySort);
  //      }
  //     }
  //   } else {
  //     // remove primary sort if necessary
  //     if (this.viewModel.parameters.sortInfo.length > 0) {
  //       this.viewModel.parameters.sortInfo.splice(0, 1);
  //     }
  //   }
  // }
  configureDefaultSortBy(): void {
    if (this.viewModel.separateBy) {
      // add primary sort field 
      if (!this.viewModel.parameters.sortInfo) {
        this.viewModel.parameters.sortInfo = [];
      }
      // default primary sort if it isn't already configured
      if (!this.viewModel.parameters.sortInfo?.find(x => x.sortField === this.viewModel.separateBy)) {
        const primarySort = new SortInfo();
        primarySort.sortAscending = true;
        primarySort.sortField = this.viewModel.separateBy;

        // add primary sort
        if (this.viewModel.parameters.sortInfo?.length === 0) {
            this.viewModel.parameters.sortInfo.splice(0, 0, primarySort);
        } else {
          // update primary sort
          this.viewModel.parameters.sortInfo.splice(0, 1, primarySort);
        }
      }
    } else {
      if (!this.viewModel.parameters.sortInfo) {
        this.viewModel.parameters.sortInfo = [];
      }
      // remove primary sort if necessary
      if (this.viewModel.parameters.sortInfo.length > 0) {
        this.viewModel.parameters.sortInfo.splice(0, 1);
      }
    }
    // default secondary sort if it isn't already configured
    if (!this.viewModel.parameters.sortInfo?.find(x => x.sortField === this.viewModel.parameters.timeColumn)) {
      const secondarySort = new SortInfo();
      secondarySort.sortAscending = true;
      secondarySort.sortField = this.viewModel.parameters.timeColumn;

      // add secondary sort
      if (this.viewModel.parameters.sortInfo.length > 0) {
        this.viewModel.parameters.sortInfo.splice(1, 0, secondarySort);
      }else {
        // update primary sort
        this.viewModel.parameters.sortInfo.splice(0, 1, secondarySort);
      }
    }
  }

  onRunChanged(event: MatSlideToggleChange): void {
    this.viewModel.rules.forEach( r => r.run = event.checked);
  }

  toggleRulesHeight(): void {
    this.isRulesMaximized = !this.isRulesMaximized;
  }

  compareDataFarm(o1: DataFarmViewModel, o2: DataFarmViewModel): boolean {
    return o1.name === o2.name && o1.id === o2.id;
  }
  
  removeSortInfo(sortInfo: SortInfo): void {
    const index = this.viewModel.sortInfo?.indexOf(sortInfo);

    if (index >= 0) {
      this.viewModel.sortInfo?.splice(index, 1);

      // delete the separateBy field if we no longer have that field sortable
      this.viewModel.syncSeparateByWithPrimarySort();
    }
  }
  
  showSortBuilder(): void {
    const dialog = this.matDialog.open(SortBuilderComponent, {
      data: {
        fields: this.viewModel.sourceColumns.map(c => c.text),
        sortItems: [...this.viewModel.sortInfo ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const items = result.sortItems;
      this.viewModel.sortInfo = items;
      //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
      this.sortCtrl.setValue(null);

      // delete the separateBy field if we no longer have that field sortable
      this.viewModel.syncSeparateByWithPrimarySort();
    });
  }

  onDeleteRule(rule: GroupAttributorRuleViewModel): void {
    this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete this rule?`, (confirmed) => {
      if (confirmed) {
        const index = this.viewModel.rules.indexOf(rule);
        this.viewModel.rules.splice(index, 1);
        this.viewModel.reindexRules();

        if ( this.viewModel.rules.length > 0 ) {
          const lastIndex = this.viewModel.rules.length - 1;
          //this.viewModel.selectedIngestConfig = this.viewModel.importDataViewModel.ingestConfigs[lastIndex];
        }
        else {
          //this.viewModel.selectedIngestConfig = null;
        }
        this.dataSource.data = this.viewModel.rules;
        this.isRuleSetEmpty = this.viewModel.rules.length === 0;
        //update rule table height
        if(this.viewModel.rules.length<=10){
          this.minrowcount=this.viewModel.rules.length;
        }else{
          this.minrowcount=10;
        }
        this.maxrowcount=this.viewModel.rules.length;
      }
    });
  }

  onDuplicateRule(sourceRule: GroupAttributorRuleViewModel): void {
    
    const vm = new GroupAttributorRuleViewModel(new GroupAttributorTransformRule());
    Object.assign(vm, sourceRule);
    
    this.viewModel.rules.splice(sourceRule.index, 0, vm);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;

    //console.log(`rule inserted at index: ${sourceRule.index}`);
    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
    if(vm.index==this.maxrowcount){this.isScrollBottom=true; }else{this.isScrollBottom=false;}
  }
  minrowcount:number=10;
  maxrowcount:number=100;
  isScrollBottom:boolean=true;
  addNewRule(): void {
    var isValidDefaultParam=true;
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==this.transformType);
    var params=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid).parameters.filter(n=>n.isruledefault==true);
    params.forEach(field => {
      if(field.jsonobject=="defSourceField"){
        if(!this.viewModel.sourceColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="defTargetField"){
        if(!this.viewModel.targetColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="userIdField"){
        if(!this.viewModel.parameters.userColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="timestampField"){
        if(!this.viewModel.parameters.timeColumn){
          isValidDefaultParam=false;
        }
      }
    });

    if (!isValidDefaultParam) {
      this.displayError("Cannot add Rule unless Default field(s) are entered.","Please fix the validation error.");
      return;
    }
    const id = this.viewModel.rules.length;
    const rule = new GroupAttributorTransformRule();
    rule.ruleId = id;
    rule.index = id;
    rule.groupFill = GroupFillType.beforeStartRow;
    rule.whenStart = WhenType.changesFrom;
    rule.whenEnd = WhenType.changesFrom;
    rule.conditionStart = ConditionType.equals;
    rule.conditionEnd = ConditionType.equals;
    rule.groupByStart = GroupByType.ignore;
    rule.groupByEnd = GroupByType.ignore;
    rule.fieldStart = this.viewModel.sourceColumn;//this.viewModel.groupBy;
    rule.fieldEnd = this.viewModel.targetColumn;//this.viewModel.groupBy;
    rule.include = this.viewModel.defInclude;
    rule.timeout = this.viewModel.defTimeout;

    const vm = new GroupAttributorRuleViewModel(rule);

    this.viewModel.rules.push(vm);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;
    this.dataSource.data = this.viewModel.rules;

    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
    try {
      return this.getClassForRowBase(sender, row, colInfo, colInfos);
    } catch (err) {
      return null;
    }
  }

  showSaveConfigDialog(onClosed: (name: string) => any ): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    const dialogRef = this.matDialog.open(SaveMappingConfigDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.name) { return; }

      // Name entered
      //console.log('User wants to save data transformer config as: ' + result.name);
      onClosed(result.name);
    });
  }

  saveConfig(): void {

    if (!this.validate()) {
      return;
    }
    this.configureDefaultSortBy();
    //console.log(this.dataTransformConfigViewModel);
//console.log('Prajna group attributor...');
    if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
      //console.log('updating...');
      this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
    } else {
      //console.log('saving...');
      this.showSaveConfigDialog(async (configName: string) => {
        this.saveConfigImpl(configName);
      });
    }
  }

  async saveConfigImpl(configName: string): Promise<void> {
    console.log("group attributor prajna");
      var currenttransformer_sampleStart = this.viewModel.parameters.sampleStart ;
      var currenttransformer_sampleEnd = this.viewModel.parameters.sampleEnd  ;
    
        if (currenttransformer_sampleStart >=  currenttransformer_sampleEnd) {
            this.displayWarning(
              'Sample Start was greater than to Sample End, so it was auto-reset to 1.',
              'Warning',
              undefined,
              () => {
                this.viewModel.parameters.sampleStart = 1;
              }
            );
            return;
          }
          if(currenttransformer_sampleStart > this.totalInputRows || currenttransformer_sampleEnd > this.totalInputRows )
        {
    
          this.displayWarning(
            'Sample Range exceeded the Input Farm size and was auto-corrected to the maximum limit.',
            'Warning',
            undefined,  // no exception to pass
            () => {
           
              if (currenttransformer_sampleStart > this.totalInputRows) {
              this.viewModel.parameters.sampleStart = 1;
              }
              if (currenttransformer_sampleEnd > this.totalInputRows) {
                this.viewModel.parameters.sampleEnd = this.totalInputRows;
              }
            }
          );
          return;
        }
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();

      config.name = configName;
      config.organizationId = 1;
      config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
      config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
      
      // Save the Data Connectors
      config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
      .map ( ingestConfig =>
        new DataConnectorMapping(
          ingestConfig.id,
          ingestConfig.name,
          ingestConfig.targetDataFarm,
          ingestConfig.dataConnector.toDataConnector(),
          ingestConfig.columnMap
            .map(i => i.toColumnMapDefinition()),
            ingestConfig.guid,
          ingestConfig.masterColumnMapGuid)
      );

      //console.log('saving config...');
      //console.log(this.dataTransformConfigViewModel);

      // Save Transforms
      config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);

      // Save the transform
      //const transform = config.transforms.find(t => t.id === this.viewModel.transform?.id) ?? this.viewModel.transformViewModel.transform;
      const transform = this.viewModel.transformViewModel.transform;
      //console.log(transform);

      transform.transformConfig = this.viewModel.toTransformConfig();

      // TODO: Verify if we need to save this info again
      // it overwrites what we had to begin with possibly causing a Bug!

      // We need a new field to map the Source Farm into 
      // This Source Farm is where the data is derived from
      
      // transform.dataFarmName = this.viewModel.dataFarm.name;
      // transform.dataFarmType = this.viewModel.dataFarm.dataFarmType;

      // TODO: Maintain list of transforms for this config
      const existingTransform = config.transforms.find(t => t.guid === transform.guid);
      if (existingTransform) {
        config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
      }
      config.transforms.push(transform);
      

      // Save the ingest transforms
      //console.log(JSON.stringify(config));

      config = await this.configService.upsertConfig(config);
      //console.log(config);
      this.userData.setSelectedConfigJson(config);
      this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
      this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
      //update preViewModel
      this.snapshotPreState();

      // SAve the current node status to Not RunConfigRequest.
      const selectedNode = this.userData.getSelectedNodeDetails();
      //const RefineryConfigJson = await this.configService.getRefineryConfigByGuidAsync(selectedNode.refineryConfigGuid);
      // //console.log('Refinery json in save = ', RefineryConfigJson) ;
      //RefineryConfigJson.nodes.filter(newNode => newNode.id == selectedNode.id)[0].data.nodeStatus = NodeRunStatus.NotRun
      //let RefineryJson = await this.configService.UpsertRefineryConfig(RefineryConfigJson);
      
      // var UpdateNodesStatus: UpdateNodesStatusRequest = new UpdateNodesStatusRequest(selectedNode.refineryConfigGuid, selectedNode.id, NodeRunStatus.PipelineModified )
      // let updateStatusreturn = await this.configService.updateUpcomingNodesStatus(UpdateNodesStatus);
      
      //Invoke the save current transformer cache api
       const activeTransformGuid = this.userData.getSelectedTransform().guid
       const userId = this.userData.getUserId()
       const orgId = this.userData.getOrgId()
       var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
       await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
       await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
       this.getCacheStatus();
       // this.cdRef.detectChanges();
      this.snackBar.open(`Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`, 'Dismiss', {
        duration: 5000
      });
      busyIndicator.close();

    } catch (err) {
      busyIndicator.close();
      this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
    }
  }
  
  onSetDefaultRule(defaultfield:string){
    if(defaultfield=="sourceColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.fieldStart=this.viewModel.sourceColumn;
      })
    }
    else if(defaultfield=="targetColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.fieldEnd=this.viewModel.targetColumn;
      })
    }
  }
  totalRulesColumnDisplay(){
    //blank values
    this.viewModel.rules.forEach(rule=>{
      rule.groupHits=null;
      rule.rowHits=null;
    })
    if(this.viewModel.parameters.runAll){
      this.displayedColumns= [
        'actions',
        'index',
        'name',
        'groupFill',
        'groupByValue',
        'fieldStart',
        'whenStart',
        'conditionStart',
        'stringStart',
        'groupByStart',
        'fieldEnd',
        'whenEnd',
        'conditionEnd',
        'stringEnd',
        'groupByEnd',
        'timeout',
        'include',
        'isEnabled',
        'sampleGroups',
        'sampleRows',
        'groups',
        'rows'];
      }else{
      this.displayedColumns= [
        'actions',
        'index',
        'name',
        'groupFill',
        'groupByValue',
        'fieldStart',
        'whenStart',
        'conditionStart',
        'stringStart',
        'groupByStart',
        'fieldEnd',
        'whenEnd',
        'conditionEnd',
        'stringEnd',
        'groupByEnd',
        'timeout',
        'include',
        'isEnabled',
        'sampleGroups',
        'sampleRows'];
    }
    this.cdRef.detectChanges();
  }
  onToggleRulesColumnDisplay(){
    this.totalRulesColumnDisplay();
  }
  onUpdateGroupsAtEnd(event: any){
    this.viewModel.updateGroupsAtEnd=event.checked;
  }
  onParameterFormStatusChange(status: boolean) {
    this.isParameterFormValid = status;
  }

  checkContainsListLength(rule: any): boolean {
    return !rule.containsList || rule.containsList.length <= 1;
  }
  onSetDefaultRuleParam(defaultfield:string):void{
    this.showConfirmDialog('', `Fill Source Field in Rules Table with Default Source Field?`, async (confirmed) => {
      if (confirmed) {
        this.onSetDefaultRule(defaultfield);
      }
    }); 
  }

  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;
 
    // Alert the tab index and label
   // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
   this.userData.setResultsTabClicked(false);
   if(selectedTabLabel.match("Output") && selectedTabIndex == 1) {
    this.userData.setOutputTabClicked(true)
    this.setOutputPreviewTabSlctnStatus();
   } else {
      this.userData.setOutputTabClicked(false);
      this.setInputPreviewFilterViewModel();
      // if(selectedTabLabel.match("Summary") && selectedTabIndex == 2) {
      //   if(this.source.length > 0) {
      //     let selectFilterInfoSummary = new SelectFilterInfo(this.source, this.selectFilterValues);
      //     this.onApplySelect(selectFilterInfoSummary);
      //   }
      // }
   }
  }

  setGroupAttributorResultsTabClicked(): void {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    
    this.userData.setOutputTabClicked(false);
    this.userData.setResultsTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    this.isResultsPanelExpanded = true;
    this.isPreviewPanelExpanded = false;
  }

  setGroupAttributorPreviewTabClicked(): void {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.isResultsPanelExpanded = false;
    this.isPreviewPanelExpanded = true;
    if(this.selectedIndex == 0) {
      this.setInputPreviewFilterViewModel();
    }
    if(this.selectedIndex == 1) {
      this.setOutputPreviewTabSlctnStatus();
    }
  }

  setInputPreviewFilterViewModel() {
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.setTransformerInputPrvwCacheKey();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel)
  }

  setOutputPreviewTabSlctnStatus(): void {
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
  }
  
  setTransformerInputPrvwCacheKey() {
    if(this.transformerInputPreviewCacheKey.length > 0 && this.inputPrvwFilterViewModel.farmId.length > 0) {
      this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = this.transformerInputPreviewCacheKey;
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    }
  }
  resetInputPrvwViewModel() {
    this.inputPrvwFilterViewModel.farmId = "";
    this.inputPrvwFilterViewModel.collookupFarmId = "";
    this.inputPrvwFilterViewModel.nodeType = "";
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
  }

  resetTransformerInputPrvwModelData() {
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
    this.inputPrvwFilterViewModel.previewType = "";
  }

  get isValidateParameters(): boolean {
    return !(this.isParameterFormValid && this.formparam.valid);
  }
  get isValidateAdvanceSettings(): boolean {
    return this.form.invalid;
  }
  sourceColumn:ParameterSetting=new ParameterSetting();
  targetColumn:ParameterSetting=new ParameterSetting();

  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==transformType);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      var params=parameters.parameters;
      this.sourceColumn=params.find(x=>x.jsonobject=='defSourceFieldStart');
      this.targetColumn=params.find(x=>x.jsonobject=='defTargetFieldEnd');
      //other parameters
      this.groupBy=params.find(x=>x.jsonobject=='groupBy');
      this.separateBy=params.find(x=>x.jsonobject=='separateBy');
      this.defTimeout=params.find(x=>x.jsonobject=='defTimeout');
      this.defInclude=params.find(x=>x.jsonobject=='defInclude');
      //advanced settings parameters
      this.bufferRows=params.find(x=>x.jsonobject=='bufferRows');
      this.threads=params.find(x=>x.jsonobject=='threads');
      this.listSeparator=params.find(x=>x.jsonobject=='listSeparator');
      this.fillOptionType=params.find(x=>x.jsonobject=='fillOption');
      this.updateGroupsAtEnd=params.find(x=>x.jsonobject=='updateGroupsAtEnd');
      this.resetRows=params.find(x=>x.jsonobject=='resetRows');
      //check this is first this.viewModel.sampleEnd =0
      if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){
        if(this.updateGroupsAtEnd.default!=""){
          this.viewModel.updateGroupsAtEnd=this.stringToBoolean(this.updateGroupsAtEnd.default);
        }
        if(this.resetRows.default!=""){
          this.viewModel.resetRows=this.stringToBoolean(this.resetRows.default);
        }
        //defSourceField
        for(let pr of this.sourceColumn.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.sourceColumn=foundColumn.value;
            break;
          }
        }
        for(let pr of this.targetColumn.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.targetColumn=foundColumn.value;
            break;
          }
        }
        
      //other parameters
        for(let pr of this.groupBy.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.groupBy=foundColumn.value;
            break;
          }
        }
        for(let pr of this.separateBy.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.separateBy=foundColumn.value;
            break;
          }
        }
        if(this.defTimeout.default!=""){
          this.viewModel.defTimeout=Number(this.defTimeout.default);
        }
        if(this.defInclude.default!=""){
          this.viewModel.defInclude=Number(this.defInclude.default);
        }
      //advanced settings parameters
        if(this.bufferRows.default!=""){
          this.viewModel.bufferRows=Number(this.bufferRows.default);
        }
        if(this.threads.default!=""){
          this.viewModel.threads=Number(this.threads.default);
        }
        if(this.listSeparator.default!=""){
          this.viewModel.listSeparator=this.listSeparator.default;
        }
      }
    }else{
      //advanced settings parameters
      // this.bufferRows.label="Buffer Rows";this.bufferRows.jsonobject="bufferRows";this.bufferRows.min=0;this.bufferRows.max=10000000;
      // this.threads.label="Threads (0 > Auto)";this.threads.jsonobject="threads";this.threads.min=0;this.threads.max=64;
      this.resetRows.label="Reset Row Numbers";this.resetRows.jsonobject="resetRows";
    }
  }
  async removeInvalidValues(): Promise<void>{
    var isvalid=true;
    var foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.sourceColumn);  
    if(!foundColumn){
      isvalid=false;
      this.viewModel.sourceColumn=undefined;
    }
    var foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.targetColumn);  
    if(!foundColumn){
      isvalid=false;
      this.viewModel.targetColumn=undefined;
    }
    var foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.groupBy);  
    if(!foundColumn){
      isvalid=false;
      this.viewModel.groupBy=undefined;
    }
    var foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.separateBy);  
    if(!foundColumn){
      isvalid=false;
      this.viewModel.separateBy=undefined;
    }
    
    // if(!isvalid){
    //   this.displayWarning("One or more fields in the configuration are  not in the input farm.","Warning.");
    // }
  }
  async loadImportTransformer(transform: any): Promise<void>{
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
        this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
        return;
      }else if(this.transformType!=transform.transformType){
        this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
        return;
      }
      var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
      ctranformconfig.transform.transformConfig=transform;
      var newmodel =new GroupAttributorViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
      // force new object reference for UI refresh
      this.viewModel.rules=[];
      this.viewModel.rules=[...newmodel.rules];
      this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      this.dataSource.data = this.viewModel.rules;
      //update Parameters
      this.viewModel.parameters.sourceColumn=newmodel.parameters.sourceColumn;
      this.viewModel.parameters.targetColumn=newmodel.parameters.targetColumn;
      this.viewModel.parameters.userColumn=newmodel.parameters.userColumn;
      this.viewModel.parameters.timeColumn=newmodel.parameters.timeColumn;
      this.viewModel.parameters.sortInfo=newmodel.parameters.sortInfo;
      this.viewModel.parameters.includeInResults=newmodel.parameters.includeInResults;
      this.viewModel.parameters.sampleStart =newmodel.parameters.sampleStart;
      this.viewModel.parameters.sampleEnd =newmodel.parameters.sampleEnd;
      this.viewModel.parameters.runAll =newmodel.parameters.runAll;
      //other parameters
      this.viewModel.groupBy = newmodel.groupBy;
      this.viewModel.separateBy = newmodel.separateBy;
      this.viewModel.defTimeout = newmodel.defTimeout;
      this.viewModel.defInclude = newmodel.defInclude;
      //advanced settings parameters
      this.viewModel.bufferRows = newmodel.bufferRows;
      this.viewModel.threads = newmodel.threads;
      this.viewModel.listSeparator = newmodel.listSeparator;
      this.viewModel.resetRows = newmodel.resetRows;
      this.viewModel.fillOptionType = newmodel.fillOptionType;
      this.viewModel.updateGroupsAtEnd = newmodel.updateGroupsAtEnd;
      //update rule table height
      if(this.viewModel.rules.length<=10){
        this.minrowcount=this.viewModel.rules.length;
      }else{
        this.minrowcount=10;
      }
      this.maxrowcount=this.viewModel.rules.length;
    }catch (err) {
      this.displayError(`Failed to save import transformer`, 'Error', err);
    }finally {
      busyIndicator.close();
    }
  }
  onEventTimeColumn(){
    this.configureDefaultSortBy();
  }
  async onRunTransformValidate() {
    this.configureDefaultSortBy();
    this.onRunTransform();
  }
  async viewTransformConfigJsonValidate() {
    this.configureDefaultSortBy();
    this.viewTransformConfigJson();
  }
  onToggleResetRows(event: any){
    this.viewModel.resetRows=event.checked;
  }
}


